import { z } from 'zod'
import { ScheduledPaymentRecurrenceSchema } from './scheduled-payment'

/** Planlanan tahsilat (nakit gelir planı) şemaları — backend, web ve mobil aynı sözleşmeyi kullanır */

const money = z.string().regex(/^\d+(\.\d{1,2})?$/, 'Geçerli bir tutar giriniz.')
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Geçerli bir tarih giriniz (YYYY-AA-GG).')

/** PARTIAL: kısmen tahsil edildi, kalan hâlâ açık */
export const SCHEDULED_RECEIPT_STATUSES = ['PLANNED', 'PARTIAL', 'RECEIVED', 'CANCELLED'] as const
export type ScheduledReceiptStatus = typeof SCHEDULED_RECEIPT_STATUSES[number]

/** Ödeyenin bağlanabileceği kayıt türleri (bağ yoksa `payer` serbest metindir) */
export const SCHEDULED_PAYER_TYPES = ['CUSTOMER', 'SUB_CONSULTANT', 'VENDOR', 'USER'] as const
export type ScheduledPayerType = typeof SCHEDULED_PAYER_TYPES[number]

/** Gecikme kovaları (gün): vadesi geçmiş açık tahsilatlar bu aralıklara göre gruplanır */
export const RECEIVABLE_AGING_BUCKETS = ['CURRENT', 'D1_30', 'D31_60', 'D61_90', 'D90_PLUS'] as const
export type ReceivableAgingBucket = typeof RECEIVABLE_AGING_BUCKETS[number]

const base = {
  title: z.string().min(2, 'Başlık zorunludur.').max(200),
  amount: money,
  currency: z.string().length(3).default('TRY'),
  dueDate: isoDate,
  payer: z.string().max(200).nullable().optional(),
  payerType: z.enum(SCHEDULED_PAYER_TYPES).nullable().optional(),
  payerId: z.string().uuid().nullable().optional(),
  projectId: z.string().uuid().nullable().optional(),
  hakedisId: z.string().uuid().nullable().optional(),
  notes: z.string().max(500).nullable().optional(),
}

export const CreateScheduledReceiptSchema = z.object({
  ...base,
  recurrence: ScheduledPaymentRecurrenceSchema.nullable().optional(),
})
export type CreateScheduledReceiptInput = z.infer<typeof CreateScheduledReceiptSchema>

/** Tek bir vadeyi günceller (tekrar kuralı sonradan değişmez; seri için silip yeniden oluşturulur) */
export const UpdateScheduledReceiptSchema = z.object({
  title: base.title.optional(),
  amount: base.amount.optional(),
  currency: base.currency.optional(),
  dueDate: base.dueDate.optional(),
  payer: base.payer,
  payerType: base.payerType,
  payerId: base.payerId,
  projectId: base.projectId,
  hakedisId: base.hakedisId,
  notes: base.notes,
})
export type UpdateScheduledReceiptInput = z.infer<typeof UpdateScheduledReceiptSchema>

/**
 * Tahsil edildi işareti. `receivedAmount` bu seferki tutardır ve öncekilere eklenir; toplam planlanana ulaşınca RECEIVED,
 * altında kalırsa PARTIAL olur. `customerPaymentId` verilirse mevcut gelir (tahsilat) kaydına bağlanır.
 */
export const CompleteScheduledReceiptSchema = z.object({
  receivedDate: isoDate,
  receivedAmount: money.optional(),
  customerPaymentId: z.string().uuid().nullable().optional(),
})
export type CompleteScheduledReceiptInput = z.infer<typeof CompleteScheduledReceiptSchema>

/** Ödeme sözü: tarih verilirse kaydedilir, `null` ise söz kaldırılır */
export const PromiseScheduledReceiptSchema = z.object({
  promisedDate: isoDate.nullable(),
  promiseNote: z.string().max(300).nullable().optional(),
})
export type PromiseScheduledReceiptInput = z.infer<typeof PromiseScheduledReceiptSchema>
